// extracted by mini-css-extract-plugin
module.exports = {"popup":"PropertiesModal_popup__1Rk8C","popup_content":"PropertiesModal_popup_content__rlWui","fieldName":"PropertiesModal_fieldName__fOY1f"};